<template>
  <div>
    <b-tabs>
      <b-tab :title="$t('message.Общие')" active>
        <b-form-group :label="$t('message.Название') + ':'" label-for="Name">
          <b-form-input
            id="Name"
            type="text"
            v-model="model.name"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          :label="$t('message.Комментарий') + ':'"
          label-for="Comment"
        >
          <b-form-input
            id="Comment"
            type="text"
            v-model="model.comment"
            required
          ></b-form-input>
        </b-form-group>
        <b-row>
          <b-col class="col-6">
            <b-form-group>
              <b-form-checkbox v-model="model.enabled" switch>
                {{ $t("message.Включен") }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col class="col-6">
            <b-form-group>
              <b-form-checkbox v-model="model.live_enabled" switch>
                {{ $t("message.Лайв-стриминг") }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-6">
            <b-form-group>
              <b-form-checkbox v-model="model.timeshift_enabled" switch>
                {{ $t("message.Timeshift_Enabled") }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group :label="$t('message.Адрес') + ':'" label-for="Address">
          <b-form-input
            id="Address"
            type="text"
            v-model="model.address"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          :label="$t('message.Обработчик') + ':'"
          label-for="Handler"
        >
          <b-form-input
            id="Handler"
            type="text"
            v-model="model.handler"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          :label="$t('message.Колокейшн') + ':'"
          label-for="Colocation"
        >
          <v-select
            v-model="model.colocation"
            :options="this.colocations"
            label="name"
          ></v-select>
        </b-form-group>
        <b-form-group
          :label="$t('message.Продолжительность_хранения_записи_(дней)') + ':'"
          label-for="DVRDepth"
        >
          <b-form-input
            id="DVRDepth"
            type="text"
            v-model="model.dvr_depth"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('message.Опции') + ':'" label-for="Options">
          <v-jsoneditor
            v-model="model.options"
            :options="options"
            :plus="false"
            @error="onJsonError"
          ></v-jsoneditor>
        </b-form-group>
      </b-tab>
      <b-tab :title="$t('message.потоки_клонирование')" v-if="hasId">
        <b-form-group label="Service original:" label-for="Service">
          <b-form-input
            id="name"
            type="text"
            v-model="model.name"
            :readonly="true"
            required
          >
          </b-form-input>
        </b-form-group>

        <b-form-group label="Service new:" label-for="Service">
          <v-select
            v-model="model.service"
            :options="this.services"
            label="name"
            :get-option-label="getLabel"
            @input="serviceSelectId($event)"
          ></v-select>
        </b-form-group>

        <b-button
          :variant="'success'"
          class="mb-1 float-right"
          @click="cloneStreams()"
          >{{ $t("message.потоки_клонирование") }}</b-button
        >
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from "vue";
import VJsoneditor from "v-jsoneditor";

export default {
  name: "ServiceForm",
  props: ["model"],
  components: {
    VJsoneditor
  },
  data() {
    return {
      colocations: [],
      options: {
        mode: "code",
        history: false,
        search: false,
        mainMenuBar: false,
        name: this.$i18n.t("message.Опции"),
        navigationBar: false
      },
      services: [],
      service_selected: ""
    };
  },
  computed: {
    hasId: function() {
      return !!this.model.id;
    }
  },
  created: function() {
    let promise_colo = this.$noname.get("colocations");
    let promise_serv = this.$noname.get("services", {
      params: { perPage: 10000 }
    });

    promise_colo
      .then(data => {
        this.colocations = data.data.items;
      })
      // .catch(this.$noname.HandleError);
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Не_удалось_получить_колокейшинов") +
            ":<br>" +
            error,
          type: "error"
        });
      });

    promise_serv
      .then(data => {
        this.services = data.data.items;
      })
      // .catch(this.$noname.HandleError);
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Не_удалось_получить_сервисов") +
            ":<br>" +
            error,
          type: "error"
        });
      });
  },
  methods: {
    getLabel(option) {
      return `[${option.id}] ${option.name} - ${option.address}`;
    },
    onJsonError() {
      console.log("error");
    },
    onValidationError: function(errors) {
      console.log(errors);
      errors.forEach(error => {
        switch (error.type) {
          case "validation": // schema validation error
            break;
          case "customValidation": // custom validation error
            break;
          case "error": // json parse error
            break;
        }
      });
    },
    serviceSelectId(e) {
      if (e) {
        this.service_selected = e.id;
      } else {
        this.service_selected = "";
      }
    },
    cloneStreams: function() {
      if (this.model.id) {
        this.$dialog
          .confirm(this.$i18n.t("message.потоки_действительно_клонировать?"))
          .then(response => {
            let promise = this.$noname.get("clone_streams", {
              params: {
                serviceOriginal: this.model.id != "" ? this.model.id : "0",
                serviceNew:
                  this.service_selected != "" ? this.service_selected : "0"
              }
            });
            promise
              .then(response => {
                Vue.notify({
                  group: "notify",
                  text: this.$i18n.t("message.потоки_клонирование_завершилось"),
                  type: "success"
                });
              })
              .catch(error => {
                Vue.notify({
                  group: "notify",
                  text:
                    this.$i18n.t("message.потоки_ошибка_клонирования") +
                    ":<br>" +
                    error,
                  type: "error"
                });
              });
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/ServiceForm.vue